<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section" id="sect5"><span href="#/OEBPS/toc#sect5" title="Link target outside of Sample">Greek Yogurt Breakfast Bark</span></h1>
<p class="figure"><img alt="" src="OEBPS/images/13-1.jpg" style="height:70vh"/></p>
<p class="RecipebYieldb">Yield: Serves 6–8 | Prep Time: 10 minutes plus 2 hours chill time | Cook Time: N/A</p>
<p class="extract_r">When I’m running late to work in the morning, I often just grab the nearest muffin or waffle and head out the door. Breakfast bark allows me to keep nibbling away at something as I try to find my purse and shoes, while still feeling good knowing that it’s full of good-for-you ingredients like fruit and nuts!</p>
<p class="ingredients"><strong>INGREDIENTS</strong></p>
<p class="rec">1½ cups Greek yogurt</p>
<p class="rec">2 tablespoons maple syrup</p>
<p class="rec">1 tablespoon honey</p>
<p class="rec">½ cup mixed berry granola, such as Quaker Real Medleys Granola</p>
<p class="rec">½ cup blueberries</p>
<p class="rec">6 strawberries, 3 sliced and 3 chopped</p>
<p class="rec">¼ cup pistachios</p>
<p class="directions"><strong>DIRECTIONS</strong></p>
<p class="recpr">1. Line a 9 × 13-inch baking pan (or 8 × 8-inch baking pan if you want a thicker bark) with parchment paper, leaving an overhang on two sides.</p>
<p class="recpr">2. In a small bowl, combine the yogurt, maple syrup, and honey.</p>
<p class="recpr">3. Pour the mixture into the baking pan and spread it to about ¼ inch to ½ inch thick.</p>
<p class="recpr">4. Sprinkle the granola, blueberries, strawberries (sliced and chopped), and pistachios over the yogurt mixture.</p>
<p class="recpr">5. Cover the baking pan with foil and place in the freezer for at least 2 hours.</p>
<p class="recpr">6. Break or cut into pieces. Put on a platter and serve.</p>
<p class="notehead"><strong>VARIATIONS</strong></p>
<p class="NotebText">Use different granola flavor combinations, fruits, and nuts. You can also add coconut and dark chocolate chips.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sect5.vue?3b7ba971